import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Draggable } from 'react-beautiful-dnd'

import LoanRow from './LoanRow'
import Loader from '../common/Loader'
import productUsesDefaultModel from '../common/helpers/productUsesDefaultModel'


const getItemStyle = (isDragging, draggableStyle) => ({
  ...draggableStyle
})

export default class AllTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...props
    }
    this.updateLoanState = this.updateLoanState.bind(this)
  }
  updateLoanState(app_number, newState) {
    const { loans } = this.state
    loans.forEach(loan => {
      if (loan.app_number === app_number) {
        Object.assign(loan, newState)
      }
    })
    this.props.sortLoans(this.props.order)
    this.setState({ loans })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  isPPPLoan = (loanInfo) => {
    return loanInfo ? loanInfo.product.category === 'paycheck_protection' : false
  }
  renderLoans = (loans) => {
    const { toggleDraggable, data, isDraggable, csrfToken, latestPredictionsForLoans = [], loansData = [] } = this.props
    const { enableEdit, customerService, activeTab, showActivity } = this.state
    const dragLoans = loans.map((loan, index) => {
      const prediction = latestPredictionsForLoans.find(prediction => prediction.loanId === loan.id)
      const loanInfo = loansData.find(l => l.rid === loan.id)
      const isPPP = this.isPPPLoan(loanInfo)
      const smartRateDisplayProps = {
        defaultProbability: prediction ? prediction.riskRating : null,
        dataPermutation: loanInfo ? loanInfo.lastPredictionDataPermutation : null,
        needsRedecision: loanInfo ? loanInfo.needsRedecision : null,
        productUsesDefaultModel: productUsesDefaultModel(loanInfo)
      }

      return (
        <Draggable
          isDragDisabled={!isDraggable}
          key={loan.id}
          draggableId={loan.id}
          index={index}
        >
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
            >
              <div className='item' key={`loan#${loan.id}`}>
                <LoanRow
                  smartRateDisplayProps={smartRateDisplayProps}
                  key={`loan#${loan.app_number}`}
                  activeTab={activeTab}
                  csrfToken={csrfToken}
                  customerService={customerService}
                  enableEdit={enableEdit}
                  loan={loan}
                  isPPP={isPPP}
                  showActivity={showActivity}
                  updateLoanState={this.updateLoanState}
                  toggleDraggable={toggleDraggable}
                />
              </div>
            </div>
          )}
        </Draggable>
      )
    }
    )
    return dragLoans
  };

  render() {
    const { loading } = this.props
    const { enableEdit, customerService, activeTab, showActivity, loans } = this.state
    if (loading) {
      return <Loader number={4} />
    }
    const today = new Date().toISOString().split('T')[0].replace(/[^0-9]+/g, '')
    let todaysLoans = []
    let olderLoans  = []
    let maxDate = today
    let renderedBody
    loans.forEach(loan => {
      const dates = loan.notifications.map(notification => parseInt(notification.date))
      if (dates.length > 0) {
        maxDate = dates.sort().slice(-1)[0]
        loan.maxDate = maxDate
        maxDate.toString().substring(0, 8) === today ? todaysLoans.push(loan) : olderLoans.push(loan)
      }
    })

    todaysLoans = todaysLoans.sort((a, b) => a.maxDate < b.maxDate)
    olderLoans  = olderLoans.sort((a, b) => a.maxDate < b.maxDate)

    if (activeTab !== 'activity') {
      renderedBody = (
        <Fragment>
          {this.renderLoans(loans)}
        </Fragment>)
    } else {
      renderedBody = (
        <Fragment>
          { todaysLoans.length > 0 &&
          <div className='item'>
            <div className='td-header' colSpan="6"><strong>TODAY</strong></div>
          </div>
          }
          { this.renderLoans(todaysLoans) }
          { olderLoans.length > 0 &&
          <div className='item'>
            <div className='td-header' colSpan="6"><strong>OLDER</strong></div>
          </div>
          }
          { this.renderLoans(olderLoans) }
        </Fragment>
      )
    }

    return (
      <Fragment>
        {renderedBody}
      </Fragment>
    )
  }
}
